import type {
  TypeBQuestionnaireExtractionEvidenceEntry,
  TypeBQuestionnaireQuestion,
} from '@/shared/hooks/api/machineryDirectiveCompliance'

export function isQuestionAnswerBlank(params: {
  question: TypeBQuestionnaireQuestion
  value: boolean | string | null
  textDraft?: string
}): boolean {
  const { question, value, textDraft } = params

  if (question.kind === 'boolean') {
    return value == null
  }

  if (question.kind === 'text') {
    const text =
      textDraft ?? (typeof value === 'string' ? value : '')
    return text.trim().length === 0
  }

  return value == null || value === ''
}

export function getExtractionEvidenceForQuestion(
  extractionEvidence: Record<string, TypeBQuestionnaireExtractionEvidenceEntry | null>,
  questionKey: string
): TypeBQuestionnaireExtractionEvidenceEntry | null | undefined {
  if (!(questionKey in extractionEvidence)) {
    return undefined
  }
  return extractionEvidence[questionKey]
}

export function shouldShowInsufficientEvidenceHint(params: {
  questionKey: string
  extractionEvidence: Record<string, TypeBQuestionnaireExtractionEvidenceEntry | null>
  isQuestionActive: boolean
  isAnswerBlank: boolean
  isHintDismissed: boolean
}): boolean {
  const {
    questionKey,
    extractionEvidence,
    isQuestionActive,
    isAnswerBlank,
    isHintDismissed,
  } = params

  if (!isQuestionActive || !isAnswerBlank || isHintDismissed) {
    return false
  }

  return getExtractionEvidenceForQuestion(extractionEvidence, questionKey) === null
}

export function hasExtractionEvidenceContent(
  entry: TypeBQuestionnaireExtractionEvidenceEntry | null | undefined
): entry is TypeBQuestionnaireExtractionEvidenceEntry {
  return entry != null
}
